<template>
  <div :style="$cmsStyles('c_54214a3559b5')" class="recruit-wrapper">
    <div class="banner-container">
      <h1 class="title">
        <div class="top">{{ $cms('c_54214a3559b5', 'f_0001', "欢迎加入魔筷") }}</div>
        <div class="bottom">{{ $cms('c_54214a3559b5', 'f_0002', "一个有梦想的组织") }}</div>
      </h1>
    </div>
    <div class="about-container">
      <h2 class="title">{{ $cms('c_54214a3559b5', 'f_0003', "关于魔筷") }}</h2>
      <p class="desc">
        {{ $cms('c_54214a3559b5', 'f_0004', "魔筷科技成立于2015年，是一家全球化的、集研发、生产、销售于一体的全球化品牌集团。") }}<br />{{ $cms('c_54214a3559b5', 'f_0005', "旗下涵盖：品牌管理公司、海外品牌管理公司、供应链运营管理公司、文化传媒公司、AI技术公司等。") }}
      </p>
      <p class="desc"></p>
      <p class="desc">{{ $cms('c_54214a3559b5', 'f_0006', "公司始终秉持“成为全球家庭健康生活的引领者”的愿景，打造了数个年销售额过亿的家庭消费品牌，真正做到了研发驱动、差异创新、产销一体、持续升级、品质保障、价格公道、客户信赖、渠道健康。公司拥有强大的自主研发团队，专注于不断推陈出新，研发生产更符合现代家庭消费场景的产品。在销售渠道方面，公司依托强大的系统能力，于线上构建了70万中小主播的分销网络；于线下布局全国销售网络，自主品牌已入驻东北区、华中区、华东区、新零售等各大商超。同时公司不断打磨AI技术能力，对内实现了全面AI智能化，推出了魔筷AI，一个更懂零售企业的AI。") }}</p>
      <p class="desc">{{ $cms('c_54214a3559b5', 'f_0007', "魔筷科技目前处于C2轮融资，曾获得快手、腾讯、唯品会、五源、高榕等多家知名企业和机构的投资认可。") }}</p>
    </div>

    <div v-show="$cms('c_54214a3559b5', 'f_0008', true)" class="box-1">
      <h2 class="title">{{ $cms('c_54214a3559b5', 'f_0009', "为什么选择魔筷") }}</h2>
      <div class="box-content">
        <div class="item" v-for="item in advantageList" :key="item.title">
          <img class="icon" :src="item.icon" alt="">
          <div class="item-title">{{ item.title }}</div>
          <div class="item-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>

    <div class="video-container">
      <h2 class="title">{{ $cms('c_54214a3559b5', 'f_0010', "“我眼中的魔筷”") }}</h2>
      <div
        class="employee-cases-wrapper"
        @mouseenter="onSwiperEnter"
        @mouseleave="onSwiperLeave"
      >
        <div class="swiper-arrow prev"></div>
        <div class="swiper-arrow next"></div>
        <!-- <div class="swiper-pagination"></div> -->
        <swiper ref="caseSwiper" :options="casesSwiperOption">
          <swiper-slide v-for="(item, index) in casesSwiperData" :key="index">
            <div class="case-item">
              <div class="video-box">
                <video
                  ref="joinVideo"
:src="$cms('c_54214a3559b5', 'f_0011', &quot;https://mktv-in-cdn.mockuai.com/16296856249533468.mp4&quot;)"
                  controls
                  class="video"
                ></video>
                <div
                  class="poster"
                  v-show="posterVisible"
                  @click="play(index)"
                >
                  <img
:src="$cms('c_54214a3559b5', 'f_0012', &quot;https://mktv-in-cdn.mockuai.com/16296900119399764.jpg&quot;)"
                    alt=""
                    class="main"
                  />
                  <img
:src="$cms('c_54214a3559b5', 'f_0013', &quot;https://mktv-in-cdn.mockuai.com/16267470199756939.png&quot;)"
                    alt=""
                    class="play-icon"
                  />
                </div>
              </div>
              
              <div class="detail">
                <div class="title">{{ item.title }}</div>
                <div class="desc">{{ item.desc }}</div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="office-container">
      <h2 class="title">{{ $cms('c_54214a3559b5', 'f_0014', "办公环境") }}</h2>
      <div class="desc">
        {{ $cms('c_54214a3559b5', 'f_0015', "魔筷科技总部坐落于杭州未来科技城核心地带的魔筷科技园，毗邻阿里巴巴全球总部与人工智能小镇，坐享数字经济产业集聚区的地缘优势。总部办公区采用开放式布局，通透明亮的办公区配备人体工学座椅，辅以4K高清会议室及5G全覆盖网络系统配置，随处可见的绿植和休闲洽谈区为员工提供了舒适的工作环境。步行10分钟左右即达的配套商业体，涵盖健身房、美食餐厅以及24小时便利店，步行5分钟即可到达文一西路地铁站（3号线），为员工打造\"15分钟品质生活圈\"") }}
      </div>
      <div class="swiper">
        <div class="swiper-arrow prev"></div>
        <div class="swiper-arrow next"></div>
        <swiper :options="officeSwiperOption">
          <swiper-slide v-for="(item, index) in officeData" :key="index">
            <div class="card-item">
              <img :src="item.image" alt="" class="main" />
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="atmosphere-container">
      <h2 class="title">{{ $cms('c_54214a3559b5', 'f_0016', "团队氛围") }}</h2>
      <div class="desc">
        {{ $cms('c_54214a3559b5', 'f_0017', "作为完成C+轮融资的准独角兽企业，魔筷科技汇聚了来自阿里巴巴等顶尖互联网企业的核心高管团队，来自全球顶尖高校和企业的数百余名成员组成多元化的专业团队，涵盖品牌、供应链、MCN、AI技术研发等不同领域。在这个充满活力的大家庭里，我们始终践行\"无界协作\"的扁平化管理理念，并始终相信优秀的人才需要自由成长的空间，因此实行弹性工作制，并设立\"创新孵化项目\"支持阿米巴式肚子运营项目。在这里，每位成员都是公司发展的合伙人，从应届毕业生到行业专家，都能在晋升计划中找到适合自己的成长路径。") }}
      </div>
      <div class="swiper">
        <div class="swiper-arrow prev"></div>
        <div class="swiper-arrow next"></div>
        <swiper :options="atmosphereSwiperOption">
          <swiper-slide v-for="(item, index) in atmosphereData" :key="index">
            <div class="card-item">
              <img :src="item.image" alt="" class="main" />
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="benefits-container">
      <h2 class="title">{{ $cms('c_54214a3559b5', 'f_0018', "福利待遇") }}</h2>
      <div class="desc">
        {{ $cms('c_54214a3559b5', 'f_0019', "我们构建了涵盖职业发展全周期的\"星链计划\"福利生态") }}
      </div>
      <ul class="items">
        <li v-for="(item, index) in benefitsData" :key="index" class="item">
          <span class="icon"></span>
          <span class="text">{{ item }}</span>
        </li>
      </ul>
      <h3 class="sub-title">{{ $cms('c_54214a3559b5', 'f_0020', "MOCKUAI TECHNOLOGY") }}</h3>
      <div class="sub-desc">
        {{ $cms('c_54214a3559b5', 'f_0021', "在魔筷星球，我们始终相信") }}<br />
        {{ $cms('c_54214a3559b5', 'f_0022', "有温度的办公空间是灵感迸发的土壤，并肩作战的默契是攻坚克难的后盾，而贴心周全的关怀则是家的归属感") }}<br />
        {{ $cms('c_54214a3559b5', 'f_0023', "这里不仅是打造未来健康生活方式的主场，更是见证每位伙伴鲜活成长的人生舞台") }}<br />
        {{ $cms('c_54214a3559b5', 'f_0024', "我们用热忱浇灌理想，用行动书写属于这个时代的职场故事，让每一个奋斗的足迹都带着温度，让每一次突破都闪耀青春的光芒") }}
      </div>
    </div>
    <div class="join-container">
      <div class="title">{{ $cms('c_54214a3559b5', 'f_0025', "期待你加入魔筷，与我们一同为梦想努力！") }}</div>
      <a :href="$cms('c_54214a3559b5', 'f_0026', &quot;mailto:hr@mockuai.com&quot;)" class="email">
        <span class="text">{{ $cms('c_54214a3559b5', 'f_0027', "简历投递：hr@mockuai.com") }}</span>
      </a>
      <div class="btn">{{ $cms('c_54214a3559b5', 'f_0028', "加入我们") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  head() { return this.$cmsHead('c_54214a3559b5', {
    title: "加入魔筷-欢迎加入魔筷科技|招聘信息|福利待遇|办公环境|魔筷科技",
    meta: [
      {
        name: "Keywords",
        content: "魔筷科技招聘,加入魔筷,魔筷招聘信息,福利待遇,办公环境,团队氛围,星链计划,弹性工作制,杭州招聘,快手,抖音,视频号,小红书,hr@mockuai.com",
      },
      {
        name: "Description",
        content:
          "欢迎加入魔筷科技！作为完成C+轮融资的准独角兽企业，我们汇聚来自阿里巴巴等顶尖互联网企业的核心团队。提供极具竞争力的薪酬福利、舒适的办公环境、弹性工作制，期待你与我们一同为梦想努力！",
      },
    ],
  }); },
  data() {
    return {
      posterVisible: true,
      advantageList: this.$cms('c_54214a3559b5', 'f_0029', [{"icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804192615930000215.17543067757975059.png","title":"让生活变成健康的样子","desc":"魔筷长期致力于“让生活变成健康的样子”的使命，打造了数十个年销售额过亿的家庭消费品牌，通过线上70万+达人分销网络与线下经销商的双渠道布局，成功链接全球超千万家庭。"},{"title":"迎接每个特别的你","icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804192615930000596.17543067757947963.png","desc":"自由包容的文化氛围让你自由发展，你的声音会被认真聆听，在这里，你遇到的不只是同事，更是并肩成长的伙伴"},{"title":"福利关怀浸透你的生活","icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804192615930000274.17543067757969031.png","desc":"你的努力会被铭记，你的付出会被真诚对待，舒适与科技融合的办公环境，极具竞争力的薪酬和激励体系，完善和个性化员工福利，只为回报你的尽心拼搏。 "}]),
      casesSwiperOption: {
        speed: 2000,
        spaceBetween: 1,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        // loop: true,
        navigation: {
          nextEl: ".swiper-arrow.next",
          prevEl: ".swiper-arrow.prev",
        },
        pagination: {
          el: ".employee-cases-wrapper .swiper-pagination",
          clickable: true,
        },
        // effect: 'fade'
      },
      casesSwiperData: this.$cms('c_54214a3559b5', 'f_0030', [{"title":"年轻、刺激、有活力的、有社会责任感的、坚定、皮实、机遇、挑战、爆炸","img":"https://mktv-in-cdn.mockuai.com/16296900119399764.jpg","video":"https://mktv-in-cdn.mockuai.com/16296856249533468.mp4","desc":""}]),
      officeSwiperOption: {
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        loop: true,
        navigation: {
          nextEl: ".swiper-arrow.next",
          prevEl: ".swiper-arrow.prev",
        },
      },
      officeData: this.$cms('c_54214a3559b5', 'f_0031', [{"image":"https://mktv-in-cdn.mockuai.com/16373092626437093.jpg"},{"image":"https://mktv-in-cdn.mockuai.com/16372891523659990.png"},{"image":"https://mktv-in-cdn.mockuai.com/16372891523635113.png"},{"image":"https://mktv-in-cdn.mockuai.com/16372891523185698.png"},{"image":"https://mktv-in-cdn.mockuai.com/16377384740406243.png"},{"image":"https://mktv-in-cdn.mockuai.com/16372891523295626.png"},{"image":"https://mktv-in-cdn.mockuai.com/16372891523373298.png"}]),
      atmosphereSwiperOption: {
        slidesPerView: 3,
        spaceBetween: "3.1538461538461537%",
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        loop: true,
        navigation: {
          nextEl: ".atmosphere-container .swiper-arrow.next",
          prevEl: ".atmosphere-container .swiper-arrow.prev",
        },
      },
      atmosphereData: this.$cms('c_54214a3559b5', 'f_0032', [{"image":"https://mktv-in-cdn.mockuai.com/16372891523081132.png"},{"image":"https://mktv-in-cdn.mockuai.com/16372891523151354.png"},{"image":"https://mktv-in-cdn.mockuai.com/16372891523271306.png"},{"image":"https://mktv-in-cdn.mockuai.com/16372891523223423.png"},{"image":"https://mktv-in-cdn.mockuai.com/16372891523329618.png"},{"image":"https://mktv-in-cdn.mockuai.com/16372891523343757.png"},{"image":"https://mktv-in-cdn.mockuai.com/16372891523392305.png"},{"image":"https://mktv-in-cdn.mockuai.com/16372891523424430.png"},{"image":"https://mktv-in-cdn.mockuai.com/16372891523432132.png"},{"image":"https://mktv-in-cdn.mockuai.com/16372891523452502.png"},{"image":"https://mktv-in-cdn.mockuai.com/16372891523471461.png"},{"image":"https://mktv-in-cdn.mockuai.com/16372891523483831.png"},{"image":"https://mktv-in-cdn.mockuai.com/16372891523508727.png"},{"image":"https://mktv-in-cdn.mockuai.com/16372891523521130.png"},{"image":"https://mktv-in-cdn.mockuai.com/16372891523532791.png"},{"image":"https://mktv-in-cdn.mockuai.com/16372891523573456.png"},{"image":"https://mktv-in-cdn.mockuai.com/16372891523599700.png"},{"image":"https://mktv-in-cdn.mockuai.com/16372891523603640.png"}]),
      benefitsData: this.$cms('c_54214a3559b5', 'f_0033', ["入薪酬保障：入职即缴五险一金，转正后叠加绩效奖金，年度享有年终奖金","弹性假期：基础带薪年假5天起步，司龄满一年解锁：每增加1年再获2天递增","团队活力：月度部门主题创意团聚，涵盖户外拓展/美食工坊/主题派对/短途旅行","兴趣培养：不定期开展社团、桌游、俱乐部等活动，形式丰富多彩","生活美学：设计师定制专属节日礼盒：端午茗茶粽礼、中秋手作月饼、新春年货盲盒、个性化生日礼遇等","今日之星：每月都有超多惊喜奖项轮番登场——「降本增效之星」「百万俱乐部」「价值观之星」「销售龙虎榜」…从周激励到年度大奖，荣誉证书、现金红包层层叠加，让优秀成为日常！"]),
    };
  },
  computed: {
    caseSwiper() {
      return this.$refs.caseSwiper.$swiper;
    },
  },
  methods: {
    onSwiperEnter() {
      this.caseSwiper.autoplay.stop();
    },
    onSwiperLeave() {
      this.caseSwiper.autoplay.start();
    },
    play() {
      this.posterVisible = false;
      this.$refs.joinVideo[0].play();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../style/common.less";

.recruit-wrapper {
  padding-top: 90px;
  .banner-container {
    position: relative;
    box-sizing: border-box;
    .pxToVw(height, 680);
    // background-image: url(https://mktv-in-cdn.mockuai.com/16274876566909160.png);
    background-image: var(--cms-c_54214a3559b5-f_0034, url("https://mktv-in-cdn.mockuai.com/16276374421256264.png"));
    background-size: cover;
    background-repeat: no-repeat;
    background-color: #00092a;
    .title {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      .top {
        line-height: 1.4;
        .pxToVw(font-size, 60);
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #fff;
      }
      .bottom {
        line-height: 1.4;
        .pxToVw(font-size, 60);
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }
  .about-container {
    position: relative;
    box-sizing: border-box;
    // .pxToVw(height, 460);
    .pxToVw(padding-top, 91);
    .pxToVw(padding-bottom, 91);
    background-color: #fff;
    &::before,
    &::after {
      content: "";
      position: absolute;
      .pxToVw(width, 33);
      .pxToVw(height, 31);
      background-size: cover;
      background-repeat: no-repeat;
    }
    &::before {
      content: "";
      .pxToVw(top, 168);
      .pxToVw(left, 520);
      background-image: var(--cms-c_54214a3559b5-f_0035, url("https://mktv-in-cdn.mockuai.com/16274884476575669.png"));
    }
    &::after {
      content: "";
      .pxToVw(bottom, 90);
      .pxToVw(right, 523);
      background-image: var(--cms-c_54214a3559b5-f_0036, url("https://mktv-in-cdn.mockuai.com/16274884532307948.png"));
    }
    > .title {
      .pxToVw(margin-bottom, 45);
      text-align: center;
      .pxToVw(line-height, 50);
      .pxToVw(font-size, 36);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    .desc {
      margin: 0;
      .pxToVw(line-height, 30);
      .pxToVw(font-size, 18);
      text-align: center;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      .pxToVw(width, 800);
      margin: 0 auto;
      .pxToVw(margin-top, 20);
      &:first-child {
        .pxToVw(margin-top, 0);
      }
    }
  }

  .box-1 {
    .pxToVw(height, 692);
    background-image: var(--cms-c_54214a3559b5-f_0037, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250731171108670000660.17539530684145417.jpg"));
    background-size: 100% 100%;
    background-repeat: no-repeat;
    > .title {
      .pxToVw(padding-bottom, 60);
      .pxToVw(padding-top, 80);
      .pxToVw(line-height, 50);
      .pxToVw(font-size, 36);
      text-align: center;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333
    }
    .box-content {
      position: relative;
      box-sizing: border-box;
      .pxToVw(padding-left, 240);
      .pxToVw(padding-right, 240);
      
      display: flex;
      .pxToVw(gap, 60);
      .item {
        flex: 1;
        .pxToVw(border-radius, 20);
        .pxToVw(height, 300);
        .pxToVw(padding-right, 30);
        .pxToVw(padding-left, 30);
        .pxToVw(padding-top, 100);
        background: #FFFFFF;
        position: relative;
        .icon {
          position: absolute;
          display: block;
          .pxToVw(width, 80);
          .pxToVw(top, -13);
          .pxToVw(right, 20);
        }
        .item-title {
          .pxToVw(font-size, 30);
          font-weight: 600;
          color: #333333;
          .pxToVw(line-height, 36);
        }
        .item-desc {
          .pxToVw(margin-top, 38);
          font-weight: 300;
          .pxToVw(font-size, 18);
          .pxToVw(line-height, 30);
          color: #666666;
        }
      }
    }
  }
  
  .video-container {
    box-sizing: border-box;
    .pxToVw(padding-top, 80);
    > .title {
      .pxToVw(padding-bottom, 60);
      text-align: center;
      .pxToVw(line-height, 50);
      .pxToVw(font-size, 36);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }

    .employee-cases-wrapper {
      box-sizing: border-box;
      position: relative;
      .pxToVw(width, 1440);
      // .pxToVw(height, 530);
      .pxToVw(padding, 60);
      .pxToVw(margin-bottom, 60);
      margin: 0 auto;
      background-color: #fff;
      box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.09);
      .pxToVw(border-radius, 16);
      .swiper-arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        .pxToVw(width, 44);
        .pxToVw(height, 44);
        background-size: cover;
        background-repeat: no-repeat;
        cursor: pointer;
        &.swiper-button-disabled {
          display: none;
        }
        &.prev {
          .pxToVw(left, 13);
          background-image: var(--cms-c_54214a3559b5-f_0038, url("https://mktv-in-cdn.mockuai.com/16252291642899934.png"));
        }
        &.next {
          .pxToVw(right, 18);
          background-image: var(--cms-c_54214a3559b5-f_0039, url("https://mktv-in-cdn.mockuai.com/16252259933873886.png"));
        }
      }
      .swiper-pagination {
        .pxToVw(bottom, 60);
        left: 50%;
        transform: translateX(-50%);
        /deep/ .swiper-pagination-bullet {
          .pxToVw(width, 24);
          .pxToVw(height, 6);
          .pxToVw(margin-right, 8);
          .pxToVw(border-radius, 4);
          background-color: #ddd;
          &:last-child {
            margin-right: 0;
          }
          &.swiper-pagination-bullet-active {
            background-color: #ff6600;
          }
        }
      }
      .swiper-container {
        .pxToVw(width, 1300);
      }
      .case-item {
        display: flex;
        align-items: center;
        background-color: #fff;
        .video-box {
          position: relative;
          // width: 37.5vw;
          .pxToVw(width, 720);
          .pxToVw(height, 404);
          .pxToVw(margin-right, 40);
          flex-shrink: 0;
          background-size: cover;
          background-repeat: no-repeat;
          cursor: pointer;
          .video {
            width: 100%;
            height: 100%;
          }
          .poster {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            cursor: pointer;
            .main {
              width: 100%;
              height: 100%;
            }
            .play-icon {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              .pxToVw(width, 92);
              .pxToVw(height, 92);
              border-radius: 50%;
            }
          }

        }
        .detail {
          .title {
            .pxToVw(margin-bottom, 42);
            .pxToVw(line-height, 50);
            .pxToVw(font-size, 36);
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #333333;
          }
          .data-box {
            display: flex;
            align-items: center;
            .data-item {
              display: flex;
              flex-direction: column;
              align-items: center;
              .pxToVw(margin-right, 80);
              &:last-child {
                margin-right: 0;
              }
              .num-line {
                display: flex;
                align-items: flex-end;
                .num {
                  .pxToVw(line-height, 68);
                  .pxToVw(font-size, 60);
                  font-family: DINCond-Light, DINCond;
                  font-weight: 300;
                  color: #333333;
                }
                .unit,
                .plus {
                  line-height: 1.4;
                  .pxToVw(font-size, 20);
                  font-family: PingFangSC-Thin, PingFang SC;
                  font-weight: 300;
                  color: #333;
                }
                .unit {
                  .pxToVw(margin-bottom, 10);
                }
                .plus {
                  align-self: center;
                }
              }
              .text-line {
                .pxToVw(line-height, 25);
                .pxToVw(font-size, 18);
                font-family: PingFangSC-Light, PingFang SC;
                font-weight: 300;
                color: #666666;
              }
            }
          }
          .desc {
            .pxToVw(width, 440);
            .pxToVw(margin-top, 40);
            .pxToVw(line-height, 25);
            .pxToVw(font-size, 18);
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 300;
            color: #666666;
          }
        }
      }
    }
    .video-box {
      position: relative;
      .pxToVw(width, 1440);
      .pxToVw(height, 810);
      margin: 0 auto;
      .pxToVw(border-radius, 16);
      .pxToVw(margin-top, 60);
      .pxToVw(margin-bottom, 80);
      overflow: hidden;
      .video {
        width: 100%;
        height: 100%;
      }
      .poster {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        cursor: pointer;
        .main {
          width: 100%;
          height: 100%;
        }
        .play-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          .pxToVw(width, 92);
          .pxToVw(height, 92);
          border-radius: 50%;
        }
      }
    }
  }
  .worth-container {
    box-sizing: border-box;
    .pxToVw(height, 434);
    .pxToVw(padding-top, 33);
    > .title {
      .pxToVw(margin-bottom, 78);
      text-align: center;
      .pxToVw(line-height, 50);
      .pxToVw(font-size, 36);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    .items {
      display: flex;
      align-items: center;
      .pxToVw(width, 1440);
      margin: 0 auto;
      .worth-item {
        .pxToVw(margin-right, 100);
        &:last-child {
          margin-right: 0;
        }
        .icon-box {
          display: flex;
          align-items: center;
          justify-content: center;
          .pxToVw(width, 120);
          .pxToVw(height, 120);
          border-radius: 50%;
          background-color: #fff;
          box-shadow: 0px 6px 19px 0px rgba(0, 0, 0, 0.06);
          .icon {
            .pxToVw(width, 72);
            .pxToVw(height, 72);
          }
        }
        .text {
          text-align: center;
          .pxToVw(margin-top, 12);
          .pxToVw(line-height, 33);
          .pxToVw(font-size, 24);
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
        }
      }
    }
  }
  .office-container {
    box-sizing: border-box;
    .pxToVw(height, 1024);
    .pxToVw(padding-top, 93);
    background-color: #f8f8f8;
    > .title {
      .pxToVw(margin-bottom, 66);
      text-align: center;
      .pxToVw(line-height, 50);
      .pxToVw(font-size, 36);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    .desc {
      .pxToVw(width, 1300);
      margin: 0 auto 35 * @unitVw;
      .pxToVw(line-height, 30);
      .pxToVw(font-size, 18);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
    .swiper {
      position: relative;
      .pxToVw(width, 1300);
      .pxToVw(border-radius, 16);
      overflow: hidden;
      margin: 0 auto;
      .swiper-arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        .pxToVw(width, 44);
        .pxToVw(height, 44);
        background-size: cover;
        background-repeat: no-repeat;
        cursor: pointer;
        &.prev {
          .pxToVw(left, -54);
          background-image: var(--cms-c_54214a3559b5-f_0040, url("https://mktv-in-cdn.mockuai.com/16274920200113393.png"));
        }
        &.next {
          .pxToVw(right, -54);
          background-image: var(--cms-c_54214a3559b5-f_0041, url("https://mktv-in-cdn.mockuai.com/16274920199899246.png"));
        }
      }
      .card-item {
        .pxToVw(width, 1300);
        .pxToVw(height, 590);
        .pxToVw(border-radius, 16);
        // overflow: hidden;
        .main {
          width: 100%;
        }
      }
    }
  }
  .atmosphere-container {
    box-sizing: border-box;
    .pxToVw(height, 743);
    .pxToVw(padding-top, 93);
    background-color: #fff;
    > .title {
      .pxToVw(margin-bottom, 60);
      text-align: center;
      .pxToVw(line-height, 50);
      .pxToVw(font-size, 36);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    .desc {
      .pxToVw(width, 1300);
      margin: 0 auto 60 * @unitVw;
      .pxToVw(line-height, 30);
      .pxToVw(font-size, 18);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
    .swiper {
      position: relative;
      .pxToVw(width, 1300);
      margin: 0 auto;
      .swiper-arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        .pxToVw(width, 44);
        .pxToVw(height, 44);
        background-size: cover;
        background-repeat: no-repeat;
        cursor: pointer;
        &.prev {
          .pxToVw(left, -54);
          background-image: var(--cms-c_54214a3559b5-f_0042, url("https://mktv-in-cdn.mockuai.com/16274920200113393.png"));
        }
        &.next {
          .pxToVw(right, -54);
          background-image: var(--cms-c_54214a3559b5-f_0043, url("https://mktv-in-cdn.mockuai.com/16274920199899246.png"));
        }
      }
      .card-item {
        .pxToVw(width, 406);
        .pxToVw(height, 280);
        .main {
          width: 100%;
        }
      }
    }
  }
  .benefits-container {
    box-sizing: border-box;
    .pxToVw(padding-top, 80);
    text-align: center;
    > .title {
      .pxToVw(margin-bottom, 60);
      .pxToVw(line-height, 50);
      .pxToVw(font-size, 36);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    .desc {
      font-weight: 300;
      .pxToVw(font-size, 24);
      .pxToVw(line-height, 30);
      color: #666666;
      .pxToVw(margin-bottom, 60);
    }
    .items {
      // .pxToVw(margin-left, 676);
      .pxToVw(width, 900);
      margin: 0 auto;
      .item {
        display: flex;
        .pxToVw(margin-bottom, 10);
        .icon {
          .pxToVw(width, 20);
          .pxToVw(height, 15);
          .pxToVw(margin-top, 3);
          .pxToVw(margin-right, 9);
          background-image: var(--cms-c_54214a3559b5-f_0044, url("https://mktv-in-cdn.mockuai.com/16274939517459632.png"));
          background-size: cover;
          background-repeat: no-repeat;
          flex-shrink: 0;
        }
        .text {
          .pxToVw(font-size, 18);
          .pxToVw(line-height, 25);
          font-weight: 400;
          color: #333333;
          text-align: left;
        }
      }
    }
    .sub-title {
      .pxToVw(font-size, 118);
      .pxToVw(line-height, 165);
      font-weight: 600;
      color: rgba(255,102,0,0.2);
    }
    .sub-desc { 
      font-weight: 300;
      .pxToVw(font-size, 18);
      .pxToVw(line-height, 30);
      color: #333333;
      .pxToVw(padding-top, 25);
      .pxToVw(padding-bottom, 60);
    }
  }
  .join-container {
    box-sizing: border-box;
    .pxToVw(height, 320);
    .pxToVw(padding-top, 115);
    background-color: #f8f8f8;
    background-image: var(--cms-c_54214a3559b5-f_0045, url("https://mktv-in-cdn.mockuai.com/16274946481825353.png"));
    background-size: cover;
    background-repeat: no-repeat;
    .title {
      .pxToVw(margin-bottom, 9);
      text-align: center;
      .pxToVw(line-height, 33);
      .pxToVw(font-size, 24);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
    .email {
      display: block;
      text-align: center;
      text-decoration: none;
      .pxToVw(line-height, 33);
      .pxToVw(font-size, 24);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff6600;
      &:hover {
        text-decoration: underline;
      }
    }
    .btn {
      .pxToVw(width, 220);
      .pxToVw(height, 60);
      .pxToVw(line-height, 60);
      .pxToVw(border-radius, 30);
      background: #FF6600;
      text-align: center;
      .pxToVw(font-size, 24);
      font-weight: 400;
      color: #fff;
      margin: 0 auto;
      .pxToVw(margin-top, 30);
    }
  }
}
</style>
